import { ShieldCheck, Headphones, CreditCard, Map } from "lucide-react";

const WhyChoose = () => {
    const trustBadges = [
        { icon: ShieldCheck, text: "Verified Trips" },
        { icon: CreditCard, text: "Secure Payments" },
        { icon: Map, text: "Local Guides" },
        { icon: Headphones, text: "24×7 Support" },
    ];

    return (
        <div className="bg-gradient-to-b from-white via-purple-50 to-white py-20">
            {/* 🔥 HEADING SECTION (IMAGE WALA TEXT) */}
            <div className="max-w-4xl mx-auto text-center px-6 mb-14">
                <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
                    Your Perfect Group Journey
                </h2>

                <p className="mt-4 text-gray-600 text-base md:text-lg">
                    Making travel simple, secure, and unforgettable through
                    thoughtfully planned experiences
                </p>
            </div>

            {/* ✅ TRUST BADGES */}
            <div className="max-w-6xl mx-auto px-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {trustBadges.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-6 flex flex-col items-center justify-center
                         shadow-md hover:shadow-xl hover:-translate-y-1
                         transition-all duration-300"
                        >
                            <div
                                className="w-14 h-14 flex items-center justify-center rounded-xl
                              bg-gradient-to-br from-purple-600 to-indigo-600 mb-3"
                            >
                                <item.icon className="w-7 h-7 text-white" />
                            </div>

                            <p className="font-semibold text-gray-800 text-sm md:text-base">
                                {item.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhyChoose;
